var render, staticRenderFns
import script from "./VerticalBarChart.vue?vue&type=script&lang=js&"
export * from "./VerticalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b821b4be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b821b4be')) {
      api.createRecord('b821b4be', component.options)
    } else {
      api.reload('b821b4be', component.options)
    }
    
  }
}
component.options.__file = "src/components/shared/charts/VerticalBarChart.vue"
export default component.exports